export default {
  methods: {
    rules () {
      return {
        required (field, maxLength, minLength) {
          return [
            v => {return typeof v === 'string' && v.length > 0 || typeof v === 'number' || !!v || (field || 'Field') + ' is required'},
            v => {return !maxLength || v && v.length <= maxLength || (field || 'Field') + ' must be less than ' + maxLength + ' characters'},
            v => {return !minLength || v && v.length >= minLength || (field || 'Field') + ' must be more than ' + minLength + ' characters'}
          ]
        },
        maxLen (maxLength, message) {
          return [
            v => {return !maxLength || !v || v && v.length <= maxLength || message}
          ]
        },
        numeric (min, max) {
          let rulesList = [
            v => {return v == null || !isNaN(v) || 'Input must be numeric'},
          ]
          if (min !== undefined) {
            rulesList.push(v => {return v == null || v >= min || 'Input must be >= ' + min})
          }
          if (max !== undefined) {
            rulesList.push(v => {return v == null || v <= max || 'Input must be <= ' + max})
          }
          return rulesList
        },
        decimals (allowedDecimalPlaces) {
          return [
            v => {
              if (v === undefined || v === null) {
                return true
              }
              if (v?.toString().indexOf('.') == -1 ?? true) {
                return true // No decimal place to worry about
              }
              const substring = v?.toString().substring(v?.toString().indexOf('.'))
              if (substring?.length - 1 <= allowedDecimalPlaces) {
                return true
              }
              return 'Maximum allowed decimal places is ' + allowedDecimalPlaces
            }
          ]
        }
      }
    }
  }
}
